import React, {FunctionComponent, ReactNode} from "react";
import {useSelector} from "react-redux";
import {RoleNameEnum} from "../../utils/types/common";

import {AppState, select} from "../../store";

type AdminRolesProps = Readonly<{
  /**
   * If roles === undefined; the component is opaque & renders children for any role.
   */
  roles?: ReadonlyArray<RoleNameEnum>;
  children: ReactNode;
}>;

export const AdminRoles = ({roles, children}: AdminRolesProps) => {
  const user = useSelector((state: AppState) =>
    select.adminSession.user(state),
  );

  // skipcq: JS-0424 - we need to return a ReactNode. Otherwise, the component will not work.
  return <>{!roles || roles?.includes(user.role.name) ? children : null}</>;
};

const createRolesComponent =
  (roles: ReadonlyArray<RoleNameEnum>): FunctionComponent =>
  ({children}) =>
    <AdminRoles roles={roles}>{children}</AdminRoles>;

const NOT_RESIDE_ADMIN_ROLES = [
  RoleNameEnum.CLERK,
  RoleNameEnum.ADMISSIONS_DIRECTOR,
  RoleNameEnum.FACILITY_ADMIN,
  RoleNameEnum.REGIONAL_ADMIN,
  RoleNameEnum.ORGANIZATION_ADMIN,
];

export const NotResideAdmin = createRolesComponent(NOT_RESIDE_ADMIN_ROLES);
